<template>
  <div>
    <div class="event-join">
      <h4>{{ joinEventDetails.EventTitle }}</h4>
      <div class="event-join_item">
        <i class="fa fa-user-circle" aria-hidden="true"></i>
        <span>{{ lang('Hosted By') }}: {{ joinEventDetails.CONname }}</span>
      </div>
      <div class="event-join_item">
        <i class="fa fa-building" aria-hidden="true"></i>
        <span>{{ lang('School') }}: {{ joinEventDetails.SCH_Name }}</span>
      </div>
      <div>
        <div class="event-join_item">
          <i class="fa fa-calendar" aria-hidden="true"></i>
          <span>{{ lang('Date') }}: {{ joinEventDetails.EventStartTime_Convert }} - {{ joinEventDetails.EventEndTime_Convert }}</span>
        </div>
        <div class="event-join_item">
          <i class="fa fa-calendar" aria-hidden="true"></i>
          <span>{{ lang('Time') }}: {{ eventHourConvert }}</span>
        </div>
      </div>

      <div v-if="parSelectedTimeslotStart !== '' && parSelectedTimeslotEnd !== ''">
        <div class="event-join_item">
          <i class="fa fa-calendar" aria-hidden="true"></i>
          <span>{{ lang('Selected Timeslot Date Time') }}: {{ parSelectedTimeslotStart }} - {{ parSelectedTimeslotEnd }}</span>
        </div>
      </div>

      <div class="event-join_item" v-if="joinEventDetails.EventParentSignUp === 'Yes'">
        <i class="fa fa-calendar" aria-hidden="true"></i>
        <span
          >{{ lang('Registration Date') }}: {{ joinEventDetails.EventRegistrationStartTime_Convert }} -
          {{ joinEventDetails.eventRegistrationCloseTime_Convert }}</span
        >
      </div>
      <div class="event-join_item" v-if="!isHoliday && joinEventDetails.EventType !== 'Elearning'">
        <i class="fa fa-map-marker" aria-hidden="true"></i>
        <span>{{ lang('Location') }}: {{ joinEventDetails.EventLocation }}</span>
      </div>

      <div v-if="!eventStart">
        <vue-countdown-timer
          @end_callback="checkEventStart('end')"
          :start-time="countdownStart"
          :end-time="countdownEnd"
          :interval="1000"
          :start-label="'Until start:'"
          :end-label="'Google meet link show time '"
          label-position="begin"
          :end-text="'Event start now!'"
          :day-txt="'days '"
          :hour-txt="'hours '"
          :minutes-txt="'minutes '"
          :seconds-txt="'seconds'"
        >
          <template slot="countdown" slot-scope="scope">
            <span>{{ scope.props.days }}</span
            ><i>{{ scope.props.dayTxt }}</i> <span>{{ scope.props.hours }}</span
            ><i>{{ scope.props.hourTxt }}</i> <span>{{ scope.props.minutes }}</span
            ><i>{{ scope.props.minutesTxt }}</i> <span>{{ scope.props.seconds }}</span
            ><i>{{ scope.props.secondsTxt }}</i>
          </template>
        </vue-countdown-timer>
      </div>

      <div v-if="this.arr_SchIDs.includes('SCH201400000480') || this.arr_SchIDs.includes('SCH201400000510')">
        <div
          class="event-join_item"
          v-if="
            !isNull(calEventHangoutLink) &&
            !isEventExpired &&
            checkShowDatetime &&
            eventStart &&
            (joinEventDetails.EventType === 'Elearning' || joinEventDetails.EventType === 'PTC')
          "
        >
          <i class="fa fa-video-camera" aria-hidden="true"></i>
          <span
            >Google Meet Link : <a :href="calEventHangoutLink" target="_blank" rel="noopener noreferrer">{{ calEventHangoutLink }}</a></span
          >
        </div>

        <div v-if="!isNull(student) && (joinEventDetails.EventType === 'Elearning' || joinEventDetails.EventType === 'PTC')">
          <div class="event-join_item" v-if="!isNull(joinEventDetails.EventCalendarID) && !isEventExpired && checkShowDatetime && eventStart">
            <span>Google Meet Code : {{ joinEventDetails.EventCalendarID }}</span>
          </div>

          <div v-for="item in student" :key="item.EventParID">
            <div class="event-join_item">
              <span style="display: block">Student Gmail : {{ item.St_SchoolEmail }}</span>
            </div>

            <div class="event-join_item">
              <span style="display: block">Student Gmail Password : {{ item.St_SchoolEmailPassword }}</span>

              <div style="display: inline-block; margin-left: 10px">
                <button class="btn btn-primary" @click="showResetModal(item.Index_No)">{{ lang('Reset Email Password') }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div
          class="event-join_item"
          v-if="!isNull(calEventHangoutLink) && !isEventExpired && (joinEventDetails.EventType === 'Elearning' || joinEventDetails.EventType === 'PTC')"
        >
          <i class="fa fa-video-camera" aria-hidden="true"></i>
          <span
            >Google Meet Link : <a :href="calEventHangoutLink" target="_blank" rel="noopener noreferrer">{{ calEventHangoutLink }}</a></span
          >
        </div>
      </div>

      <div v-if="!isNull(joinEventDetails.EventRemarks)">
        <label>{{ lang('Remarks') }} : </label>
        <el-input v-model="joinEventDetails.EventRemarks" type="textarea" :rows="6" readonly="readonly">
          {{ joinEventDetails.EventRemarks }}
        </el-input>
      </div>

      <div class="" v-if="!isNull(arrobj_SelectedFiles)">
        <label>Attachment</label>
        <div v-for="obj_Images in arrobj_SelectedFiles">
          -
          <a :href="getFile(obj_Images)" :download="`${obj_Images.EventFIleName}`" class="filepath">
            {{ obj_Images.EventFIleName }}
          </a>
        </div>
      </div>

      <div
        class="event-invitation"
        v-if="
          parent.length > 0 &&
          parent[0].eligibleRegistrationAction !== 'Not Eligible' &&
          eventRdEventType !== 'PTC' &&
          joinEventDetails.EventType !== 'Elearning'
        "
      >
        <strong class="ei-title">{{ lang('INVITATION') }}</strong>
        <div class="ei-person" v-for="item in student" :key="item.EventParID">
          <div class="ei-name">
            <strong>{{ lang('Student') }}: {{ item.Full_Name }}</strong>
          </div>
          <div class="event-join_btn">
            <el-button
              type="info"
              icon="el-icon-close"
              circle
              class="rejectBtn"
              @click="setFalseStatus(item)"
              :class="{ 'is-active': item.status === 'Withdraw' }"
            ></el-button>
            <el-button
              type="info"
              icon="el-icon-check"
              circle
              class="joinBtn"
              @click="setTrueStatus(item)"
              :class="{ 'is-active': item.status === 'Join' }"
            ></el-button>
          </div>
        </div>

        <div v-if="joinEventDetails.EventParentSignUp === 'Yes'">
          <div v-if="parent[0].eligibleRegistrationAction === 'Withdraw'">
            <div class="ei-person" v-for="item in parent" :key="item.PaxName">
              <div class="ei-name">
                <strong>{{ lang('Parent') }}</strong>
              </div>
              <div class="event-join_btn">
                <el-button
                  type="info"
                  icon="el-icon-close"
                  circle
                  class="rejectBtn"
                  @click="setFalseStatus(item)"
                  :class="{ 'is-active': item.status === 'Withdraw' }"
                ></el-button>
                <el-button
                  type="info"
                  icon="el-icon-check"
                  circle
                  class="joinBtn"
                  @click="setTrueStatus(item)"
                  :class="{ 'is-active': item.status === 'Join' }"
                ></el-button>
              </div>
            </div>
          </div>
          <div v-else class="ei-person" v-for="(item, i) in parent" :key="i">
            <div class="ei-name">
              <strong>{{ lang('Parent') }}</strong>
            </div>
            <div class="event-join_btn">
              <el-button
                type="info"
                icon="el-icon-close"
                circle
                class="rejectBtn"
                @click="setFalseStatus(item)"
                :class="{ 'is-active': item.status === 'Withdraw' }"
              ></el-button>
              <el-button
                type="info"
                icon="el-icon-check"
                circle
                class="joinBtn"
                @click="setTrueStatus(item)"
                :class="{ 'is-active': item.status === 'Join' }"
              ></el-button>
            </div>
          </div>
          <!--<span class="ei-role">Guest Pax</span>-->
          <div class="ei-person">
            <div class="ei-name">
              <strong>{{ lang('Guest Pax') }}</strong>
            </div>
            <div class="event-join_btn">
              <el-input-number v-model="guestpax" :min="0" :max="5" label="Guest Pax"></el-input-number>
            </div>
          </div>
        </div>

        <div class="ei-submit">
          <el-button type="primary" round @click="saveEventRegister()">{{ lang('Submit') }}</el-button>
        </div>
      </div>

      <div class="event-conference-option-container" v-if="joinEventDetails.EventType === 'PTC'" style="margin-top: 10px">
        <el-checkbox v-model="optEventConference" :disabled="['online', 'offline'].includes(joinEventDetails.EventFormat)">
          <span>{{ lang('Add Conferencing') }}</span>
        </el-checkbox>
      </div>

      <div class="generated-time-slot-container" style="width: 100%" v-if="eventRdEventType === 'PTC' && arrobj_generatedTimeslot.length > 0">
        <small style="font-weight: 500; color: #777; font-size: 0.8em">{{ lang('Select Timeslot') }}</small>

        <div class="each-time-slot-list" :id="dateKey" v-for="(val, dateKey) in arrobj_generatedTimeslot">
          <header class="" role="tab" style="border-bottom: 1px solid #dee2e6">
            <div class="row">
              <div class="col-12 header-tag">
                <div class="btn btn-primary" style="border-left: unset">
                  <div v-b-toggle="'date-' + dateKey" style="height: 25px">
                    <span>{{ val.eventTimeslotDate }}</span>
                  </div>
                </div>
              </div>
            </div>
          </header>
          <b-collapse :id="'date-' + dateKey" role="tabpanel">
            <div class="col-md-12" style="padding: 20px 10px 10px 10px">
              <div
                class="each-time-slot-table"
                @click="
                  selectTimeslot(
                    $event,
                    timeslot.EventTimeslotID,
                    timeslot.EventTimeslotUserStatus,
                    timeslot.EventTimeslotEventParID,
                    timeslot.EventTimeslotCalendarID,
                  )
                "
                v-for="(timeslot, timeKey) in val.eventTimeslot"
                :id="timeslot.EventTimeslotID"
                :class="[
                  timeslot.EventTimeslotUserStatus === 'enable' ? '' : 'disable',
                  timeslot.CONid !== userSessionID && timeslot.EventTimeslotUserStatus === 'disable' ? 'hidden' : '',
                ]"
              >
                <span class="ptc-par-name" v-if="selectedPar.SelectedTimeslotID === timeslot.EventTimeslotID">{{ selectedPar.SelectedPaxName }}</span>
                <span>{{ convertDatetime(timeslot.EventTimeslotStart, 'time') }} - {{ convertDatetime(timeslot.EventTimeslotEnd, 'time') }}</span>
              </div>

              <div>
                <span v-if="checkTimeslotHidden(val.eventTimeslot)">{{ lang('All timeslots are booked') }}</span>
              </div>
            </div>
          </b-collapse>
        </div>
      </div>
    </div>

    <b-modal
      id="modal_resetPassword"
      :title="lang('Reset Password')"
      ref="modal_resetPassword"
      centered
      :ok-title="lang('Confirm')"
      @ok="resetStudentGmailPassword('Reset', resetPassIndexNo)"
      :cancel-title="lang('Cancel')"
    >
      <div class="form-group">
        <h4>{{ lang('Are you sure want to reset student gmail password') }}</h4>
      </div>
    </b-modal>

    <b-modal
      id="modal_DeleteTimeslot"
      :title="lang('Delete Confirmation')"
      ref="modal_DeleteTimeslot"
      centered
      :ok-title="lang('Confirm')"
      @ok="ptcConfirmed()"
      :cancel-title="lang('Cancel')"
    >
      <div class="form-group">
        <h5>{{ lang('Are you sure want to unselect this timeslot') }}</h5>
      </div>
    </b-modal>
  </div>
</template>
<script>
import DataSource from '../../data/datasource'
import moment from 'moment'
import { lang } from '../../locale/index'
import Cookies from 'js-cookie'

import Vue from 'vue'
import VueCountdownTimer from 'vuejs-countdown-timer'
Vue.use(VueCountdownTimer)

export default {
  name: 'Event_ParentModal_Component',
  data() {
    return {
      joinEventDetails: [],
      fatherJoinStatus: '',
      motherJoinStatus: '',
      studentJoinStatus: '',
      allParticipant: [],
      student: '',
      parent: [],
      guest: '',
      parentEligible: '',
      eventID: '',
      isHoliday: true,
      eventHourConvert: '',
      guestStatus: '',
      guestpax: '',

      arrobj_generatedTimeslot: [],
      arrobj_Timeslot: [],
      arrobj_respEventTimeslot: [],
      ptcParticipant: '',
      isAvailable: true,
      isClickCount: 0,
      eventTimeslotID: '',
      eventParID: '',
      selectedTimeslotID: '',
      isDefaultTimeslot: false,
      selectedPar: {},
      calEventHangoutLink: '',
      calEventID: '',
      dropdownTimeslotDate: '',
      optEventConference: true,

      isExpired: false,
      arrobj_SelectedFiles: [],
      isEventExpired: false,
      checkShowDatetime: false,
      schoolID: '',
      arr_SchIDs: [],
      serverCurrentDatetime: '',
      countdownStart: '',
      countdownEnd: '',
      eventStart: false,
      showCountdownMsg: true,
      resetPassIndexNo: '',

      parSelectedTimeslotStart: '',
      parSelectedTimeslotEnd: '',
      dltTimeslotID: '',
      dltTimeslotStatus: '',
      dltTimeslotParID: '',
      dltTimeslotCalendarID: '',
      userSessionID: '',
    }
  },
  mounted() {
    this.initEvent()
  },
  created() {
    this.userSessionID = Cookies.get('userIDSession')
  },
  props: ['propJoinEventDetails', 'propEventAllParticipant', 'propEventID', 'eventRdEventType', 'propArrobj_SelectedFiles', 'paramServerCurrentDatetime'],
  methods: {
    lang,
    async initEvent() {
      this.schoolID = Cookies.get('schoolSession')
      this.schoolIDs = JSON.parse(this.schoolID)
      this.schoolIDs = this.schoolIDs.Table

      this.arr_SchIDs = []
      this.schoolIDs.forEach((object, index) => {
        this.arr_SchIDs.push(object.SCH_Ids)
      })

      this.joinEventDetails = this.propJoinEventDetails

      if (this.paramServerCurrentDatetime) {
        this.serverCurrentDatetime = this.paramServerCurrentDatetime
      }

      this.convertEventTime()
      this.allParticipant = this.propEventAllParticipant
      this.eventID = this.propEventID

      if (this.eventRdEventType !== 'PTC') {
        if (this.arr_SchIDs.includes('SCH201400000480') || this.arr_SchIDs.includes('SCH201400000510')) {
          this.participantList()
          this.addStatusinArray()
        }
      }
      this.checkHoliday()

      if (this.eventRdEventType === 'PTC') {
        this.getPtcParticipant()
      }

      this.checkDateExpired(moment(this.joinEventDetails.EventEndTime).format('DD/MM/YYYY'))
      this.checkEventExpired()

      if (this.propArrobj_SelectedFiles.Table && !this.isNull(this.propArrobj_SelectedFiles.Table)) {
        this.arrobj_SelectedFiles = this.propArrobj_SelectedFiles.Table
      }

      if (this.eventRdEventType === 'Elearning') {
        this.calEventHangoutLink = this.joinEventDetails.EventLink
        this.calEventID = this.joinEventDetails.EventCalendarID
      }

      if (this.joinEventDetails.EventFormat === 'online') {
        this.optEventConference = true
      }

      if (this.joinEventDetails.EventFormat === 'offline') {
        this.optEventConference = false
      }
    },
    convertEventTime() {
      this.eventHourConvert =
        moment(this.joinEventDetails.EventStartTime).format('hh:mm A') + ' - ' + moment(this.joinEventDetails.EventEndTime).format('hh:mm A')
    },
    checkHoliday() {
      // console.log(this.joinEventDetails);
      if (this.joinEventDetails.EventType !== 'SchoolClosure' && this.joinEventDetails.EventType !== 'PublicHoliday') {
        this.isHoliday = false
      }
    },
    participantList() {
      this.student = this.allParticipant.filter(x => x.EventParType === 'Student')
      let parentStatus = this.allParticipant.filter(x => x.EventParType === 'Parent')

      // console.log(parentStatus, "parent list");
      if (parentStatus.length > 0) {
        if (parentStatus[0].eligibleRegistrationAction !== 'Not Eligible' && !parentStatus[0].EventParID) {
          this.student.forEach(m => {
            let objects = {
              EventParID: '',
              status: '',
              EventParType: 'Parent',
            }

            this.parent.push(objects)
          })
        } else {
          this.parent = parentStatus
        }
      }

      this.guest = this.allParticipant.filter(x => x.EventParType === 'Guest')

      // this.guestpax = this.guest[0].EventParCount;
      this.guestpax = this.guest.length > 0 && this.guest[0].EventParCount ? this.guest[0].EventParCount : 0
    },
    addStatusinArray() {
      this.student.forEach(m => {
        if (m.EventParStatus === 'Pending') {
          m.status = ''
        } else if (m.EventParStatus === 'Active') {
          m.status = 'Join'
        } else {
          m.status = m.EventParStatus
        }
      })
      this.parent.forEach(x => {
        if (x.EventParStatus === 'Active') {
          x.status = 'Join'
        } else if (x.EventParStatus === 'Withdraw') {
          x.status = x.EventParStatus
        }
      })
    },
    setFalseStatus(item) {
      item.status = 'Withdraw'
      this.$forceUpdate()
    },
    setTrueStatus(item) {
      item.status = 'Join'
      this.$forceUpdate()
    },
    async saveEventRegister() {
      try {
        let ParticipantObj = []
        this.student.forEach(x => {
          let studentList = {
            paxType: x.EventParType,
            action: x.status,
            EventParID: x.EventParID,
          }
          ParticipantObj.push(studentList)
        })
        this.parent.forEach(x => {
          if (x.status === '') {
            let parentList = {
              paxType: 'Parent',
              action: '',
              EventParID: '',
            }
            ParticipantObj.push(parentList)
          } else {
            let parentList = {
              paxType: 'Parent',
              action: x.status,
              EventParID: x.EventParID,
            }
            ParticipantObj.push(parentList)
          }
        })

        this.guest.forEach(x => {
          if (this.guestpax === 0) {
            let guestList = {
              paxType: 'Guest',
              action: 'Withdraw',
              noOfGuest: this.guestpax,
              EventParID: x.EventParID,
            }
            ParticipantObj.push(guestList)
          } else {
            let guestList = {
              paxType: 'Guest',
              action: 'Join',
              noOfGuest: this.guestpax,
              EventParID: x.EventParID,
            }
            ParticipantObj.push(guestList)
          }
        })

        let allParticipant = JSON.stringify(ParticipantObj)
        const response = await DataSource.shared.saveEventRegistration(this.eventID, allParticipant)
        if (response.code === '88') {
          console.log('88')
          window.location.replace('/')
        } else if (response.code === '99') {
          console.log('99')
        } else if (response.code === '1') {
          this.$notify({
            title: lang('Success'),
            message: lang('Event Registered'),
            type: 'success',
          })
          this.$emit('hideNonStaffEventModal')
        }
      } catch (e) {
        console.log(e)
      }
    },

    async getEventTimeslot() {
      this.$vs.loading()

      let timeslotResp = await DataSource.shared.getPtcTimeslots(this.eventID)

      if (timeslotResp.Table) {
        this.arrobj_Timeslot = timeslotResp.Table
        this.convertedEventTimeslotDisplay()
        this.checkAvailableTimeslot()
      }
      this.$vs.loading.close()
    },

    async getPtcParticipant() {
      let ptcParResp = await DataSource.shared.getPtcParticipant(this.eventID)

      if (ptcParResp.Table) {
        this.arrobj_ptcParticipant = ptcParResp.Table
      }

      this.getEventTimeslot()
      // this.checkAvailableTimeslot();
    },

    convertedEventTimeslotParam() {
      this.arrobj_Timeslot = []

      this.arrobj_generatedTimeslot.forEach(objectDate => {
        objectDate.eventTimeslot.forEach(objectTimeslot => {
          this.arrobj_Timeslot.push(objectTimeslot)
        })
      })
    },

    convertedEventTimeslotDisplay() {
      this.arrobj_respEventTimeslot = []
      let arrTimeslotDate = []
      let timeslotDate = ''

      this.arrobj_Timeslot.forEach(objectTimeslot => {
        if (timeslotDate === '' || timeslotDate !== moment(objectTimeslot.EventTimeslotStart).format('DD/MM/YYYY')) {
          arrTimeslotDate.push(moment(objectTimeslot.EventTimeslotStart).format('DD/MM/YYYY'))
        }

        if (objectTimeslot.EventTimeslotEventParID && objectTimeslot.EventTimeslotUserStatus) {
          this.isDefaultTimeslot = true
        }

        timeslotDate = moment(objectTimeslot.EventTimeslotStart).format('DD/MM/YYYY')
        objectTimeslot.convertedTimeslotDate = moment(objectTimeslot.EventTimeslotStart).format('DD/MM/YYYY')
      })
      let arr_convertTimeslot = this.groupBy(this.arrobj_Timeslot, 'convertedTimeslotDate')

      let arrobj_eventTimeslotDate = []
      for (var a = 0; a < arrTimeslotDate.length; a++) {
        let obj_eventTimeslotDate = {}

        // if (arrTimeslotDate[a] >= moment().format("DD/MM/YYYY")) {
        obj_eventTimeslotDate.eventTimeslotDate = arrTimeslotDate[a]
        if (a === 0) {
          obj_eventTimeslotDate.isActive = true
        } else {
          obj_eventTimeslotDate.isActive = false
        }

        for (var b = 0; b < arr_convertTimeslot[arrTimeslotDate[a]].length; b++) {
          arr_convertTimeslot[arrTimeslotDate[a]][b].EventTimeslotStart = moment(arr_convertTimeslot[arrTimeslotDate[a]][b].EventTimeslotStart).format(
            'DD/MM/YYYY HH:mm:ss',
          )
          arr_convertTimeslot[arrTimeslotDate[a]][b].EventTimeslotEnd = moment(arr_convertTimeslot[arrTimeslotDate[a]][b].EventTimeslotEnd).format(
            'DD/MM/YYYY HH:mm:ss',
          )

          if (arr_convertTimeslot[arrTimeslotDate[a]][b].EventTimeslotEventParID) {
            if (arr_convertTimeslot[arrTimeslotDate[a]][b].EventTimeslotEventParID === this.arrobj_ptcParticipant[0].EventParID) {
              this.calEventHangoutLink = arr_convertTimeslot[arrTimeslotDate[a]][b].EventTimeslotHangoutLink
              this.calEventID = arr_convertTimeslot[arrTimeslotDate[a]][b].EventTimeslotCalendarID
            }
          }
        }

        obj_eventTimeslotDate.eventTimeslot = arr_convertTimeslot[arrTimeslotDate[a]]
        arrobj_eventTimeslotDate.push(obj_eventTimeslotDate)
        // }
      }

      this.arrobj_generatedTimeslot = arrobj_eventTimeslotDate
      // this.convertedEventTimeslotParam();
    },

    groupBy(array, key) {
      const result = {}
      array.forEach((item, index) => {
        if (!result[item[key]]) {
          result[item[key]] = []
        }
        result[item[key]].push(item)
      })
      return result
    },

    previousDate(key) {
      this.arrobj_generatedTimeslot.forEach((object, index) => {
        if (key - 1 === index) {
          object.isActive = true
        } else {
          object.isActive = false
        }
      })
    },
    nextDate(key) {
      this.arrobj_generatedTimeslot.forEach((object, index) => {
        if (key + 1 === index) {
          object.isActive = true
        } else {
          object.isActive = false
        }
      })
    },

    convertDatetime(datetimeVal, type) {
      if (type === 'date') {
        return moment(datetimeVal, 'DD/MM/YYYY LT').format('DD/MM/YYYY')
      } else {
        return moment(datetimeVal, 'DD/MM/YYYY LT').format('LT')
      }
    },

    checkAvailableTimeslot() {
      this.selectedPar = {}
      this.isAvailable = true
      // EventTimeslotEventParID
      this.arrobj_Timeslot.forEach(objectTimeslot => {
        if (objectTimeslot.EventTimeslotEventParID) {
          // objectTimeslot.EventTimeslotEventParID !== undefined
          this.arrobj_ptcParticipant.forEach(objectPar => {
            if (objectTimeslot.EventTimeslotEventParID === objectPar.EventParID) {
              this.isAvailable = false
              this.selectedTimeslotID = objectTimeslot.EventTimeslotID

              this.selectedPar.SelectedPaxName = objectPar.Full_Name
              this.selectedPar.SelectedTimeslotID = objectTimeslot.EventTimeslotID

              this.parSelectedTimeslotStart = moment(objectTimeslot.EventTimeslotStart, 'DD/MM/YYYY HH:mm:ss').format('MMM DD, YYYY HH:mm:ss')
              this.parSelectedTimeslotEnd = moment(objectTimeslot.EventTimeslotEnd, 'DD/MM/YYYY HH:mm:ss').format('MMM DD, YYYY HH:mm:ss')
            }
          })
        }
      })

      if (this.eventRdEventType === 'PTC') {
        this.checkEventExpired()
      }
    },

    selectTimeslot(e, timeslotID, timeslotStatus, timeslotParID, timeslotCalendarID) {
      this.eventTimeslotID = timeslotID

      if (this.isAvailable) {
        if (this.isClickCount === 0) {
          if ((!timeslotParID || this.isNull(timeslotParID)) && timeslotStatus === 'enable') {
            this.$vs.loading()

            if (timeslotStatus === 'disable') {
              $('#' + timeslotID).css('background', 'rgba(0, 0, 0, 0)')
              this.isClickCount = 0
            } else {
              // $("#"+timeslotID).css("background", "#409eff");
              $('#' + timeslotID).css('background', 'grey')
              this.isClickCount = 1
            }

            this.arrobj_generatedTimeslot.forEach((objectDate, indexDate) => {
              objectDate.eventTimeslot.forEach((objectTimeslot, indexTimeslot) => {
                // objectTimeslot.calEventHangoutLink = "";
                // objectTimeslot.calEventID = "";

                if (objectTimeslot.EventTimeslotID === timeslotID) {
                  this.parSelectedTimeslotStart = ''
                  this.parSelectedTimeslotEnd = ''

                  let randomRequestID = Math.random().toString(36).substring(2, 15)
                  let calendarStart = moment(objectTimeslot.EventTimeslotStart, 'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
                  let calendarEnd = moment(objectTimeslot.EventTimeslotEnd, 'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')

                  this.parSelectedTimeslotStart = moment(objectTimeslot.EventTimeslotStart, 'DD/MM/YYYY HH:mm:ss').format('MMM DD, YYYY HH:mm:ss')
                  this.parSelectedTimeslotEnd = moment(objectTimeslot.EventTimeslotEnd, 'DD/MM/YYYY HH:mm:ss').format('MMM DD, YYYY HH:mm:ss')

                  if (timeslotStatus === 'disable') {
                    objectTimeslot.EventTimeslotUserStatus = 'enable'
                  } else {
                    objectTimeslot.EventTimeslotUserStatus = 'disable'
                    this.isAvailable = false
                    this.selectedTimeslotID = objectTimeslot.EventTimeslotID
                    objectTimeslot.CONid = this.userSessionID
                  }

                  if (objectTimeslot.EventTimeslotEventParID) {
                    this.eventParID = objectTimeslot.EventTimeslotEventParID
                  } else {
                    this.eventParID = this.arrobj_ptcParticipant[0].EventParID
                  }

                  objectTimeslot.EventTimeslotEventParID = this.eventParID

                  this.selectedPar.SelectedPaxName = this.arrobj_ptcParticipant[0].Full_Name
                  this.selectedPar.SelectedTimeslotID = objectTimeslot.EventTimeslotID

                  if (this.optEventConference) {
                    // this.joinEventDetails.eventIsConference
                    this.generateHangsoutLink(randomRequestID, calendarStart, calendarEnd).then(resp => {
                      if (resp) {
                        if (this.calEventHangoutLink == null || this.calEventHangoutLink === '') {
                          this.$notify({
                            title: lang('Fail'),
                            message: 'Conference link not generated. \n Please try again. \nIf problem persist please contact admin for help ',
                            type: 'failure',
                          })
                        } else {
                          this.calEventHangoutLink = resp.hangoutLink
                          this.calEventID = resp.id
                          objectTimeslot.EventTimeslotCalendarID = resp.id
                        }
                        this.saveParentTimeslotBooking()
                        this.$vs.loading.close()
                      }
                    })
                  } else {
                    if (this.calEventID !== '') {
                      this.deleteCalendarEvent()
                    }

                    this.calEventHangoutLink = ''
                    this.calEventID = ''
                    this.saveParentTimeslotBooking()
                  }
                }
              })
            })

            // this.saveParentTimeslotBooking();
            this.convertedEventTimeslotParam()
            this.$emit('rerenderInit')
          } else {
            alert('Timeslot taken, Please select others timeslot!')
          }
        }
      } else {
        if (this.selectedTimeslotID === timeslotID) {
          this.showDeleteConfirmationPTC(e, timeslotID, timeslotStatus, timeslotParID, timeslotCalendarID)

          // this.calEventID = timeslotCalendarID;
          // // this.deleteCalendarEvent();
          // this.calEventHangoutLink = "";
          //
          // $("#"+timeslotID).css("background", "rgba(0, 0, 0, 0)");
          // this.isClickCount = 0;
          // this.eventParID = this.arrobj_ptcParticipant[0].EventParID;
          // this.isAvailable = true;
          // this.selectedPar = {};
          // this.parSelectedTimeslotStart = "";
          // this.parSelectedTimeslotEnd = "";
          //
          // this.arrobj_generatedTimeslot.forEach((objectDate, indexDate) => {
          //     objectDate.eventTimeslot.forEach((objectTimeslot, indexTimeslot) => {
          //         if (objectTimeslot.EventTimeslotID === timeslotID) {
          //             objectTimeslot.EventTimeslotEventParID = "";
          //             objectTimeslot.EventTimeslotUserStatus = "enable";
          //         }
          //     });
          // });
          //
          // try {
          //     let delResp = DataSource.shared.deletePTCTimesolt(timeslotID);
          // } catch (e) {
          //     console.log(e);
          // }
        } else {
          alert('Only can select 1 timeslot!')
        }
      }
    },

    async saveParentTimeslotBooking() {
      if (this.eventTimeslotID !== '' && this.eventParID !== '') {
        let timeslotBookingResp = await DataSource.shared.saveTimeslotBooking(
          this.eventTimeslotID,
          this.eventParID,
          this.eventID,
          this.calEventHangoutLink,
          this.calEventID,
        )

        // console.log(timeslotBookingResp.code, "response");
        if (timeslotBookingResp.code === '1') {
          this.$notify({
            title: lang('Success'),
            message: 'Link Added!',
            type: 'success',
          })
        } else {
          this.$notify.error({
            title: lang('Error'),
            message: 'Link failed',
          })
          console.log(timeslotBookingResp.code, 'save timeslot error code')
        }

        this.$vs.loading.close()
      } else {
        console.log(this.eventTimeslotID, 'timeslot ID')
        console.log(this.eventParID, 'par ID')
      }
    },

    isNull(obj) {
      return obj === null || obj === undefined || obj === 'undefined' || obj.length === 0 || obj === ''
    },

    async generateHangsoutLink(randID, calStart, calEnd) {
      await this.deleteCalendarEvent()

      let evtType = 'hangoutsMeet'
      let attendeeEmail = Cookies.get('userEmailSession')
      let calEventTitle = this.joinEventDetails.EventTitle + ' (' + this.selectedPar.SelectedPaxName + ')'

      let googleCalendarResp = await DataSource.shared.createGoogleCalendarEvent(
        this.joinEventDetails.CONEmail,
        calEventTitle,
        this.joinEventDetails.EventLocation,
        attendeeEmail,
        calStart,
        calEnd,
        randID,
        evtType,
        'ptcWithLink',
      )

      return googleCalendarResp
    },

    async deleteCalendarEvent() {
      let attendeeEmail = Cookies.get('userEmailSession')

      try {
        let delResp = await DataSource.shared.deleteGoogleCalendarEvent(this.calEventID, this.joinEventDetails.CONEmail)
      } catch (e) {
        console.log(e)
      }
    },

    checkDateExpired(valDate) {
      if (valDate < moment(this.serverCurrentDatetime).format('DD/MM/YYYY')) {
        this.isExpired = true
      } else {
        this.isExpired = false
      }
    },

    getFile(file) {
      return `data:${file.EventFileType};base64,${file.EventFileOriginal}`
    },

    checkEventExpired() {
      this.isEventExpired = false
      let expiredDatetime = moment().format('DD/MM/YYYY HH:mm:ss')
      let eventEndDatetime = moment(this.joinEventDetails.EventEndTime).add(1, 'hours').format('DD/MM/YYYY HH:mm:ss')

      if (moment(eventEndDatetime, 'DD/MM/YYYY HH:mm:ss').unix() <= moment(this.serverCurrentDatetime).unix()) {
        this.isEventExpired = true
      }

      let eventStartDatetime = moment(this.joinEventDetails.EventStartTime).add(-24, 'hours').format('DD/MM/YYYY HH:mm:ss')
      if (this.arr_SchIDs.includes('SCH201400000480') || this.arr_SchIDs.includes('SCH201400000510')) {
        if (moment(eventStartDatetime, 'DD/MM/YYYY HH:mm:ss').unix() <= moment(this.serverCurrentDatetime).unix()) {
          this.checkShowDatetime = true
        }

        this.countdownStart = moment(this.serverCurrentDatetime).format('YYYY-MM-DD HH:mm:ss')

        if (this.eventRdEventType !== 'PTC') {
          this.countdownEnd = moment(eventStartDatetime, 'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
        } else if (this.eventRdEventType === 'PTC') {
          this.countdownEnd = moment(this.parSelectedTimeslotStart, 'MMM DD, YYYY HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
        }

        // this.countdownEnd = moment(eventStartDatetime, "DD/MM/YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss");
        let eventCountdown = moment(this.evtStartDatetime).add(-24, 'hours').format('DD/MM/YYYY HH:mm:ss')

        // if (moment(eventCountdown, "DD/MM/YYYY HH:mm:ss").unix() <= moment(this.serverCurrentDatetime).unix()) {
        //     this.eventStart = false;
        // }

        if (moment(eventStartDatetime, 'DD/MM/YYYY HH:mm:ss').unix() >= moment(this.serverCurrentDatetime).unix()) {
          this.eventStart = false
        }
      } else {
        this.checkShowDatetime = true
      }
    },

    checkEventStart(type) {
      this.eventStart = true
    },

    async resetStudentGmailPassword(mode, indexNo) {
      try {
        this.$vs.loading()

        const response = await DataSource.shared.studentEmailAction(mode, indexNo)

        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            this.$notify.error({
              title: 'Error',
              message: 'Email Action Error!',
            })
          } else if (response.code === '2') {
            this.$notify.error({
              title: 'Error',
              message: 'Email Action Error!',
            })
          } else {
            if (mode === 'Reset') {
              this.$notify({
                title: 'Success',
                message: 'Email password successfully reseted!',
              })

              this.student.forEach((studItem, studIndex) => {
                if (studItem.Index_No === indexNo) {
                  studItem.St_SchoolEmailPassword = response.emailPassword
                }
              })
            }
          }
        }

        this.$vs.loading.close()
      } catch (e) {
        this.results = e
      }
    },

    showResetModal(indexNo) {
      this.resetPassIndexNo = ''
      this.resetPassIndexNo = indexNo
      this.$refs.modal_resetPassword.show()
    },
    hideResetModal() {
      this.$refs.modal_resetPassword.hide()
    },

    showDeleteConfirmationPTC(e, timeslotID, timeslotStatus, timeslotParID, timeslotCalendarID) {
      this.dltTimeslotID = timeslotID
      this.dltTimeslotStatus = timeslotStatus
      this.dltTimeslotParID = timeslotParID
      this.dltTimeslotCalendarID = timeslotCalendarID

      this.$refs['modal_DeleteTimeslot'].show()
    },

    hideDeleteConfirmationPTC() {
      this.$refs['modal_DeleteTimeslot'].hide()
    },

    async ptcConfirmed() {
      this.calEventID = this.dltTimeslotCalendarID
      this.deleteCalendarEvent()
      this.calEventHangoutLink = ''

      $('#' + this.dltTimeslotID).css('background', 'rgba(0, 0, 0, 0)')
      this.isClickCount = 0
      this.eventParID = this.arrobj_ptcParticipant[0].EventParID
      this.isAvailable = true
      this.selectedPar = {}
      this.parSelectedTimeslotStart = ''
      this.parSelectedTimeslotEnd = ''

      this.arrobj_generatedTimeslot.forEach((objectDate, indexDate) => {
        objectDate.eventTimeslot.forEach((objectTimeslot, indexTimeslot) => {
          if (objectTimeslot.EventTimeslotID === this.dltTimeslotID) {
            objectTimeslot.EventTimeslotEventParID = ''
            objectTimeslot.EventTimeslotUserStatus = 'enable'
            objectTimeslot.CONid = ''
          }
        })
      })

      try {
        let delResp = await DataSource.shared.deletePTCTimesolt(this.dltTimeslotID)

        if (delResp.code === '88') {
          console.log('88')
          window.location.replace('/')
        } else if (delResp.code === '99') {
          console.log('99')
          this.$notify.error({
            title: lang('Error'),
            message: lang('Delete Error'),
          })
        } else {
          this.$notify({
            title: lang('Success'),
            message: lang('Successful'),
            type: 'success',
          })

          await this.getEventTimeslot()
          await this.$emit('rerenderInit')
        }
      } catch (e) {
        console.log(e)
      }
    },

    checkTimeslotHidden(tsVal) {
      let isCheck = true
      tsVal.forEach((objectTimeslot, indexTimeslot) => {
        if (objectTimeslot.EventTimeslotUserStatus === 'enable') {
          isCheck = false
        }
      })

      return isCheck
    },
  },
}
</script>
<style scoped>
.event-invitation {
  border-top: 1px solid #eee;
  padding: 20px 0;
}

strong.ei-title {
  margin-bottom: 6px;
  display: block;
}

.ei-person {
  background: #fafafa;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #eee;
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}

.ei-name * {
  display: block;
}

.ei-name span {
  font-size: 12px;
  color: #949494;
}

.event-join_btn {
  display: table;
  margin-left: auto;
}

span.ei-role {
  margin-top: 10px;
  display: block;
  color: #999;
  font-size: 14px;
}

.ei-submit {
  margin-left: auto;
  display: table;
  padding: 20px 0 0;
}

/*.generated-time-slot-container .each-date-time-slot {*/
/*    display: none;*/
/*}*/

/*.generated-time-slot-container .each-date-time-slot.active {*/
/*    display: block;*/
/*}*/

.generated-time-slot-date-container {
  margin-bottom: 20px;
}

.each-time-slot-table {
  padding: 5px;
  display: inline-block;
  text-align: center;
  cursor: pointer;
  margin: 0 10px 20px 0;
  border: 1px solid #409eff;
  width: 80px; /*100px*/
  font-size: 12px;
  position: relative;
}

.each-time-slot-table.disable {
  /*background: #ccc;*/
  /*background: #409eff;*/
  background: grey;
  color: white;
}

.each-time-slot-table.hidden {
  display: none;
}

.ptc-par-name {
  display: block;
  position: absolute;
  top: -15px;
  background: #f7f7f7;
  border-radius: 4px;
  color: black;
  max-width: 68px;
  line-height: 1;
}
</style>
<style>
.event-join_btn .el-switch__label--left.is-active {
  color: #f56c6c;
}

.event-join_btn .el-button--info {
  background: #ffffff;
  border: 0px;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  color: #53d575;
  font-weight: bold;
}

.event-join_btn .el-button--info i {
  font-weight: bold;
}

.event-join_btn .el-button--info.is-active {
  background: #53d575;
  color: #fff !important;
}

.event-join_btn .el-button--info.is-active.rejectBtn {
  background: #f9514e;
}

.event-join_btn .el-button--info.rejectBtn {
  color: #f9514e;
  width: 40px;
}

.event-join_btn .el-button--info.joinBtn {
  width: 40px;
}
</style>
